function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e00f8b29-403f-49ff-8333-7ba1d1f65b42{fill-rule:evenodd}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10,19.5A9.5,9.5,0,1,1,19.49,10,9.51,9.51,0,0,1,10,19.5ZM10,1.44A8.56,8.56,0,1,0,18.55,10,8.57,8.57,0,0,0,10,1.44Z",
  transform: "translate(-0.51 -0.5)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.19,13a5.61,5.61,0,0,0,8.63-5,4.17,4.17,0,0,0,1-1,4.37,4.37,0,0,1-1.14.31,1.88,1.88,0,0,0,.87-1.1,3.57,3.57,0,0,1-1.25.48,2,2,0,0,0-1.44-.62A2,2,0,0,0,9.93,8.51a5.65,5.65,0,0,1-4.07-2,2,2,0,0,0,.62,2.63,2,2,0,0,1-.9-.25,2,2,0,0,0,1.58,2,1.87,1.87,0,0,1-.88,0A1.93,1.93,0,0,0,8.12,12.2,4,4,0,0,1,5.19,13Z",
  className: "e00f8b29-403f-49ff-8333-7ba1d1f65b42",
  transform: "translate(-0.51 -0.5)"
});

var SvgHandlesSocialIconTwitter = function SvgHandlesSocialIconTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bc82f59f-bdb9-4244-9f17-b04cc3aa69b4",
    "data-name": "Layer 1",
    viewBox: "0 0 18.98 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHandlesSocialIconTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Handles_SocialIcon_Twitter.4ae33c6c.svg";
export { ForwardRef as ReactComponent };